import { DIRECTION, IDirection } from '@sanlam-glacier/app-common/components';
import { Section14ClientRenewalModel } from 'bff';
import { Section14UrgencyTab } from 'modules/my-practice/types/section-14/section-14.enums';

export const formatSection14Clients = (
  unsortedData: Section14ClientRenewalModel[]
): {
  all: Section14ClientRenewalModel[];
  upcoming: Section14ClientRenewalModel[];
  late: Section14ClientRenewalModel[];
} => {
  const filterByDue = (
    clients: typeof unsortedData,
    tab: Section14UrgencyTab,
    filterPredicate: (inv: (typeof clients)[0]['investments'][0]) => boolean
  ) =>
    clients
      .map((client) => {
        const investments = client.investments.filter(filterPredicate);
        if (tab === Section14UrgencyTab.upcoming) {
          return investments.length
            ? {
                ...client,
                investments: [...investments].sort((a, b) => a.daysUntilDue - b.daysUntilDue),
                numLateRenewals: client.investments.length - investments.length
              }
            : null;
        }
        return investments.length
          ? {
              ...client,
              investments: [...investments].sort((a, b) => a.daysUntilDue - b.daysUntilDue),
              numUpcomingRenewals: client.investments.length - investments.length
            }
          : null;
      })
      .filter(Boolean) as typeof unsortedData;

  const formattedClients = {
    [Section14UrgencyTab.all]: unsortedData.map((client) => {
      return {
        ...client,
        investments: [...client.investments].sort((a, b) => a.daysUntilDue - b.daysUntilDue)
      };
    }),
    [Section14UrgencyTab.upcoming]: filterByDue(
      unsortedData,
      Section14UrgencyTab.upcoming,
      (inv) => inv.daysUntilDue >= 0
    ),
    [Section14UrgencyTab.late]: filterByDue(
      unsortedData,
      Section14UrgencyTab.late,
      (inv) => inv.daysUntilDue < 0
    )
  };

  const defaultSortedClients = {
    [Section14UrgencyTab.all]: sortByRenewalDate(
      formattedClients[Section14UrgencyTab.all],
      DIRECTION.DESC
    ),
    [Section14UrgencyTab.upcoming]: sortByRenewalDate(
      formattedClients[Section14UrgencyTab.upcoming],
      DIRECTION.DESC
    ),
    [Section14UrgencyTab.late]: sortByRenewalDate(
      formattedClients[Section14UrgencyTab.late],
      DIRECTION.ASC
    )
  };

  return defaultSortedClients;
};

export const sortByRenewalDate = (
  clients: Section14ClientRenewalModel[],
  direction: IDirection
) => {
  return clients.sort((a, b) => {
    if (direction === DIRECTION.DESC) {
      if (
        a.investments[0]?.daysUntilDue !== undefined &&
        b.investments[0]?.daysUntilDue !== undefined
      ) {
        return a.investments[0]?.daysUntilDue - b.investments[0]?.daysUntilDue;
      }
    } else if (
      a.investments[0]?.daysUntilDue !== undefined &&
      b.investments[0]?.daysUntilDue !== undefined
    ) {
      return b.investments[0]?.daysUntilDue - a.investments[0]?.daysUntilDue;
    }

    return 0;
  });
};
